import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type { TypeParams } from './types'

/** @see {@link ec.models.Api} */
@ngCore.Injectable({ providedIn: 'root' })
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => (context ? gql.queries.appPages.execute(context) : rxjs.of([])),
  )

  /** @inheritdoc */
  public create: ec.models.Api<TypeParams>['create'] = (context, input) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.addPages
      .executor({
        appId: context.appId,
        input: [gql.inputs.appPage.INPUT.getGqlFrom(input)],
        tenantId: context.tenantId,
        zoneId: context.zoneId,
      })
      .pipe(rxjs.map(pages => pages[0]))
  }

  /** @inheritdoc */
  public update: ec.models.Api<TypeParams>['update'] = (
    context,
    { id, updates },
  ) => {
    TypeAsserter.assertIsNotNullish(context)

    return gql.mutations.updatePage.executor({
      appId: context.appId,
      tenantId: context.tenantId,
      updatePageId: id,
      updates: gql.inputs.appPage.UPDATES.getGqlFrom(updates),
      zoneId: context.zoneId,
    })
  }

  /** @inheritdoc */
  public delete: ec.models.Api<TypeParams>['delete'] = (context, id) => {
    TypeAsserter.assertIsNotNullish(context)
    return gql.mutations.removePages.executor({
      ...context,
      removePageIds: [id],
    })
  }

  /**
   * Retrieves the attributes for the app page model.
   */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of([
      ec.models.Attribute.fromKey<TypeParams>('name', { name: 'Name' }),
      {
        getValueFrom: entity => !!entity.display,
        id: 'isVisible',
        name: 'Is Visible?',
        valueInfo: {
          type: ents.core.common.value.types.Intrinsic.Boolean,
        },
      },
      {
        getValueFrom: entity => entity.display?.position ?? 0,
        id: 'position',
        name: 'Position',
        valueInfo: {
          type: ents.core.common.value.types.Intrinsic.Integer,
        },
      },
    ])
}
